module.exports = __webpack_public_path__ + "img/xiaozi_gongxutong.5cc3724d.png";